function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
export class RemoveRelatedProductWarningComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleSubmit", () => {
      const {
        productId,
        onSubmit,
        onClose
      } = this.props;
      onSubmit(productId);
      onClose();
    });
  }
  render() {
    const {
      open,
      onClose
    } = this.props;
    return /*#__PURE__*/React.createElement(ConfirmDialog, {
      open: open,
      title: "Hey, these changes will apply to all products!",
      msg: "This product will be removed from cart completely, even if it is in a box",
      cancelText: "No, Leave Product",
      confirmText: "Yes, Remove Product",
      onCancel: onClose,
      onConfirm: this.handleSubmit
    });
  }
}